import { useNavigate } from "react-router-dom";
import s from './WelcomeScreen.module.css'
import PageContainer from '../common/PageContainer'
import imgReady from "../../assets/images/areYouReady.webp"
import imgCameraLeft from "../../assets/images/camera_left.webp"
import imgCameraRight from "../../assets/images/camera_right.webp"
import imgUserIcon from "../../assets/images/user_icon.webp"
import PreSaleTimer from '../common/PreSaleTimer'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useEffect } from "react";

const WelcomeScreen = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state: RootState) => state.game.user);
    const { metadata } = useSelector((state: RootState) => state.game);
    useEffect(() => {
        if (user.active_state >= 1) {
            navigate("/social");
        }
    }, [user.active_state]);

    const joinWhitelist = () => {
        dispatch({ type: 'game/updateState', payload: 1 })
    };

    return (
        <PageContainer>
            <div className={s.container}>
                <div className={s.innerContainer}>
                    <div className={s.timerContainer}>
                        <h1 className={s.titlePreSale}>WHITELIST ENDS IN:</h1>
                        <PreSaleTimer />
                    </div>

                    <img className={s.imgReady} src={imgReady} alt="ready" />

                    <p className={s.usersText}>Users in whitelist so far:</p>
                    <div className={s.usersBox}>
                        <img className={s.imgUserIcon} src={imgUserIcon} alt="user" />
                        <p className={s.usersTextBox}>{metadata.users_waitlist}</p>
                    </div>

                    <div className={s.buttonWrapper}>
                        <div className={s.glow}></div>
                        <button className={s.buttonJoin} onClick={joinWhitelist} type="button">
                            <p className={s.btnText}>Join whitelist</p>
                        </button>
                    </div>

                    <img className={s.imgCameraLeft} src={imgCameraLeft} alt="camera" />
                    <img className={s.imgCameraRight} src={imgCameraRight} alt="camera" />
                </div>
            </div>
        </PageContainer>
    )
}

export default WelcomeScreen